import { AVAILABLE_SERVICE, Consultation, CONSULTATION_STATUS, CONSULTATION_TYPE } from '@abiglobalhealth/go-types'

const CONSULTATION_ENDED_STATUS = [
  CONSULTATION_STATUS.CLOSED,
  CONSULTATION_STATUS.CANCELED,
  CONSULTATION_STATUS.CLOSED_WORATING,
  CONSULTATION_STATUS.CLOSED_WITH_REPORT_ACCESS,
  CONSULTATION_STATUS.REPORT_ACCESS_EXPIRED
]

export const isConsultationEnded = (consultation: Consultation): boolean => CONSULTATION_ENDED_STATUS.includes(consultation.status)

export const isPrescription = (consultationType: AVAILABLE_SERVICE): boolean => consultationType === CONSULTATION_TYPE.PRESCRIPTION

export const isVideoConsultation = (consultationType: AVAILABLE_SERVICE): boolean => consultationType === CONSULTATION_TYPE.VIDEO
